<div class="caption-bar">
  <div class="caption">{{ "hours.overview" | translate }}</div>
  <ion-button (click)="this.openHoursFormModal(null)">
    <ion-icon size="large" name="add"></ion-icon>
  </ion-button>
</div>

<lib-hours-overview></lib-hours-overview>
